import { FeatureTeaser } from '../FeatureTeaser';
import chargeGo from '../../../assets/images/landingPage/charge-and-go.webp';
import { CustomFormattedMessage } from '../../../i18n/i18n';
import { useLocale } from '../../../i18n/locale';

export const chargeAndGoExplanationLink = (locale: string) =>
  window.open(
    `https://rio.cloud/${locale.split('-')[0]}/marketplace/produkt/man-charge-and-go`,
    '_blank',
    'noopener',
  );

export const ChargeAndGoTeaser = () => {
  const { locale } = useLocale();

  return (
    <FeatureTeaser
      image={chargeGo}
      headline={
        <CustomFormattedMessage
          id={'landing.partnerTeaser.chargeAndGo.headline'}
        />
      }
      content={
        <CustomFormattedMessage id={'landing.partnerTeaser.chargeAndGo.body'} />
      }
      data-testid={'charge-and-go-teaser'}
      onClick={() => chargeAndGoExplanationLink(locale)}
    />
  );
};
